import { render, staticRenderFns } from "./paperpiles.html?vue&type=template&id=5fc85cc8&scoped=true&external"
import script from "./paperpiles.js?vue&type=script&lang=js&external"
export * from "./paperpiles.js?vue&type=script&lang=js&external"
import style0 from "./paperpiles.scss?vue&type=style&index=0&id=5fc85cc8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc85cc8",
  null
  
)

export default component.exports